import React from 'react';
import Lottie from 'lottie-react';
import appAnimation from '../../assets/app-development/app-hero-animation.json';
import '../../styles/service-hero.css';
import './AppDevHeroSection.css';

const BENEFITS = [
  'Markenpräsenz und Kundenbindung steigern',
  'Geschäftsprozesse mobil optimieren',
  'Messbaren Mehrwert generieren',
  'Mit Ihren Ambitionen skalieren',
];

const AppDevHeroSection = () => {
  return (
    <section className="appdev-hero">
      <div className="service-hero-copy">
        <h1 className="service-hero-title">
          Mobile Apps, maßgeschneidert für Ihr Unternehmen
        </h1>
        <p className="service-hero-lead">
          Native und plattformübergreifende Apps für iOS und Android – von der
          ersten Idee bis zum Release im App Store. Technologisch aktuell,
          nutzerzentriert gestaltet und auf Wachstum ausgelegt.
        </p>
        {/* <div className="service-hero-actions">
          <ProjektanfrageButton />
        </div> */}
      </div>

      <div className="appdev-hero-showcase">
        <div className="appdev-hero-text">
          <h2>Apps, die begeistern</h2>
          <p>
            Unser Entwicklungsprozess kombiniert moderne Technologie mit
            nutzerzentriertem Design. Das Ergebnis sind Apps, die:
          </p>
          <ul className="appdev-benefits-list">
            {BENEFITS.map((benefit) => (
              <li key={benefit}>{benefit}</li>
            ))}
          </ul>
        </div>
        <div className="appdev-hero-animation">
          <Lottie animationData={appAnimation} loop autoplay />
        </div>
      </div>
    </section>
  );
};

export default AppDevHeroSection;
